import React from 'react';

const Content = () => {
  return (
    <div className='py-10'>
      <div className='container mx-auto flex flex-col items-center px-4 text-center lg:px-16'>
        {/* Main Heading */}
        <h1 className='mb-10 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
          Empower your team with a memorable trip.
        </h1>

        {/* Description */}
        <p className='text-justify text-gray-700 md:text-center'>
          Corporate Travel Management in India has become a niche in the travel industry. BlueLagoon
          Travels caters to Corporate Clients of all sizes. Whether it is corporate incentive Trips,
          Exhibitions, Destination Wedding, Conference Management Services of Event Planning &
          themes, we offer a bouquet of professional services that make your event unique and
          memorable. We keep in mind the social and business requirements of our clients, as well as
          the unique services requested by corporate travellers and professionals from different
          fields. We ensure that we cater to their requirements in a totally customized manner.
        </p>
      </div>
    </div>
  );
};

export default Content;
